module.exports = __webpack_public_path__ + "img/CM-SL-24-Honda-Modern.3eb9c38e.jpg";